import React from 'react';
import { NavLink } from 'react-router-dom';
import { isProdEnv } from '../utils/environment';
import styles from './Navigation.module.scss';

const Navigation: React.FC = () => {
  return (
    <nav className={styles.navContainer}>
      <div className={styles.navSection}>
        <h3 className={styles.navSectionTitle}>Main</h3>
        <ul className={styles.navList}>
          <li>
            <NavLink
              to="/live"
              className={({ isActive }) => isActive ? `${styles.navLink} ${styles.active}` : styles.navLink}
            >
              Live & Upcoming Matches
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/matches"
              className={({ isActive }) => isActive ? `${styles.navLink} ${styles.active}` : styles.navLink}
            >
              Matches List
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/vod-highlights"
              className={({ isActive }) => isActive ? `${styles.navLink} ${styles.active}` : styles.navLink}
            >
              Highlights & Condensed Matches
            </NavLink>
          </li>
          {!isProdEnv() && (
            <li>
              <NavLink
                to="/vods"
                className={({ isActive }) => isActive ? `${styles.navLink} ${styles.active}` : styles.navLink}
              >
                VODs
              </NavLink>
            </li>
          )}
        </ul>
      </div>

      <div className={styles.navSection}>
        <h3 className={styles.navSectionTitle}>Management</h3>
        <ul className={styles.navList}>
          <li>
            <NavLink
              to="/tournaments"
              className={({ isActive }) => isActive ? `${styles.navLink} ${styles.active}` : styles.navLink}
            >
              Tournaments
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/players"
              className={({ isActive }) => isActive ? `${styles.navLink} ${styles.active}` : styles.navLink}
            >
              Players
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/teams"
              className={({ isActive }) => isActive ? `${styles.navLink} ${styles.active}` : styles.navLink}
            >
              Teams
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/courts"
              className={({ isActive }) => isActive ? `${styles.navLink} ${styles.active}` : styles.navLink}
            >
              Complexes/Courts
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/feed-mapping"
              className={({ isActive }) => isActive ? `${styles.navLink} ${styles.active}` : styles.navLink}
            >
              Feed Mapping
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/feeds"
              className={({ isActive }) => isActive ? `${styles.navLink} ${styles.active}` : styles.navLink}
            >
              Feeds
            </NavLink>
          </li>
        </ul>
      </div>

      <div className={styles.navSection}>
        <h3 className={styles.navSectionTitle}>Site Content</h3>
        <ul className={styles.navList}>
          <li>
            <NavLink
              to="/content"
              end
              className={({ isActive }) => isActive ? `${styles.navLink} ${styles.active}` : styles.navLink}
            >
              Placements
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/content/widgets"
              className={({ isActive }) => isActive ? `${styles.navLink} ${styles.active}` : styles.navLink}
            >
              Widget Library
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/content/articles"
              className={({ isActive }) => isActive ? `${styles.navLink} ${styles.active}` : styles.navLink}
            >
              Articles
            </NavLink>
          </li>
        </ul>
      </div>

      <div className={styles.navSection}>
        <h3 className={styles.navSectionTitle}>Subscriptions &amp; Access</h3>
        <ul className={styles.navList}>
          <li>
            <NavLink
              to="/mvpd-providers"
              className={({ isActive }) => isActive ? `${styles.navLink} ${styles.active}` : styles.navLink}
            >
              MVPD Providers
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/promotions"
              className={({ isActive }) => isActive ? `${styles.navLink} ${styles.active}` : styles.navLink}
            >
              Promotions
            </NavLink>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navigation;

